import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
export var useOrderStore = defineStore('orderStore', function () {
    var deliveryPrice = computed(function () {
        var _a;
        if (!((_a = deliveryService.value) === null || _a === void 0 ? void 0 : _a.price) || (deliveryService.value.free && orderSum.value >= deliveryService.value.free)) {
            return 0;
        }
        return deliveryService.value.price;
    });
    var orderSum = ref(0);
    var paymentSystems = ref([]);
    var paymentSystem = ref(0);
    var bonusAmount = ref(0);
    var usedBonuses = ref();
    var city = ref('');
    var delivery = ref();
    var deliveryService = ref();
    var totalSum = computed(function () { return orderSum.value + deliveryPrice.value; });
    var citySelected = computed(function () { return city.value && city.value.length >= 4; });
    var currentPaymentSystem = computed(function () {
        return paymentSystems.value.find(function (system) { return system.id === paymentSystem.value; });
    });
    var sumToPay = computed(function () { return totalSum.value - (usedBonuses.value || 0); });
    function setOrderSum(sum) {
        orderSum.value = sum;
    }
    function setCity(newCity) {
        city.value = newCity;
    }
    function setDeliveryService(newDelivery) {
        delivery.value = newDelivery ? newDelivery.id : undefined;
        deliveryService.value = newDelivery;
    }
    return {
        // delivery
        delivery: delivery,
        deliveryService: deliveryService,
        deliveryPrice: deliveryPrice,
        setDeliveryService: setDeliveryService,
        // payment systems
        paymentSystems: paymentSystems,
        paymentSystem: paymentSystem,
        currentPaymentSystem: currentPaymentSystem,
        // city
        city: city,
        citySelected: citySelected,
        setCity: setCity,
        // bonuses
        bonusAmount: bonusAmount,
        usedBonuses: usedBonuses,
        // totals
        orderSum: orderSum,
        totalSum: totalSum,
        sumToPay: sumToPay,
        setOrderSum: setOrderSum,
    };
});
